
import { defineComponent } from "vue";
import DefaultComponent from "./default.vue";
import Visualizer from "../ssa_components/visualizer/3dView.vue";
import Hierarchy from "../ssa_components/hierarchy/index.vue";
import Handle from "./handle.vue";
import PickTable from "../ssa_components/visualizer/pickTable.vue";
import { usePanelStore } from "@/stores/panelStore";

export default defineComponent({
	setup() {
		const panelStore = usePanelStore();
		return { panelStore };
	},
	name: "LayoutComponent",
	props: {
		children: {
			type: Array,
			default: () => []
		},
		id: {
			type: Number,
			default: null
		},
		componentName: {
			type: String,
			default: ""
		},
		stacked: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ""
		},
		component: {
			type: String,
			default: "LayoutComponent"
		},
		componentState: {
			type: Object,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		}
	},
	computed: {
		panelLayout() {
			return this.panelStore.panelLayout;
		}
	},
	components: {
		DefaultComponent,
		Visualizer,
		Hierarchy,
		PickTable,
		Handle
	}
});
